import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { DocumentListView } from "@/components/knowledge/document-list-view";

interface DocumentsSearchParams {
  sourceId: string;
  sourceName?: string;
}

export const Route = createFileRoute("/workspace/$workspaceSlug/knowledge/documents")({
  validateSearch: (search: Record<string, unknown>): DocumentsSearchParams => {
    return {
      sourceId: typeof search.sourceId === "string" ? search.sourceId : "",
      sourceName: typeof search.sourceName === "string" ? search.sourceName : undefined,
    };
  },
  loader: async ({ parentMatchPromise }) => {
    const parent = await parentMatchPromise;
    const workspaceId = parent?.loaderData?.workspaceId;

    if (!workspaceId || typeof workspaceId !== "string") {
      throw new Error("Workspace ID is required");
    }

    return { workspaceId };
  },
  component: DocumentsPage,
});

function DocumentsPage() {
  const { workspaceId } = Route.useLoaderData();
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  if (!search.sourceId) {
    // Redirect back to sources if no sourceId provided
    void navigate({
      to: "/workspace/$workspaceSlug/knowledge/sources",
      params: { workspaceSlug },
    });
    return null;
  }

  return (
    <DocumentListView
      workspaceId={workspaceId}
      sourceId={search.sourceId}
      sourceName={search.sourceName}
    />
  );
}
